import React from "react";
import { BundleInterface } from "src/store/community/bundlesSlice";
import Card from "src/componets/Card";
import SettingProducts from "../../Settings/_partials/_Products";
import { useAppDispatch, useAppSelector } from "src/store/hooks";
import {selectSettingById, SettingInterface} from "src/store/community/settingsSlice";
import { updateSetting } from "src/actions/community/settingsActions";
import { message } from "antd";

const _Products = ({ bundle }: { bundle: BundleInterface | undefined }) => {
  const dispatch = useAppDispatch();
  const settingId = bundle?.setting;
  const setting = useAppSelector(state => settingId ? selectSettingById(state, settingId) : undefined);
  const params: any = { ...setting?.data };

  if (!bundle) {
    return null;
  }

  function onFinish(data: SettingInterface['data']) {
    handleSave(data).catch(console.error);
  }

  async function handleSave(data: SettingInterface['data']) {
    const id = setting?.id;
    const newData: any = { data: { products: [] } };

    if (!id) {
      return;
    }

    data.products.forEach((product: any) => {
      newData.data.products.push({
        product_id: product.product_id,
        value: product.value
      })
    });

    const resultAction = await dispatch(updateSetting({ id, data: newData }));

    if (updateSetting.fulfilled.match(resultAction)) {
      message.success('Products updated successfully');
    }
  }

  return (
    <>
      <Card className='v-mb-20'>
        <h4 className='v-content-title'>Products</h4>

        <div style={{ maxWidth: 380 }}>
          <SettingProducts
            onFinish={onFinish}
            params={params}
          />
        </div>
      </Card>
    </>
  );
}

export default _Products;
